/**
 * Создаёт функцию обрезки текста с собственным кэшем внутри замыкания.
 * Перед вызовом возвращённой функции необходимо задать ctx.font —
 * иначе измерение будет по дефолтному шрифту канваса.
 */
export function createTruncateText(): (ctx: CanvasRenderingContext2D, text: string, maxWidth: number) => string {
    const cache: Record<string, string> = {};

    return function truncateTextWithEllipsis(ctx: CanvasRenderingContext2D, text: string, maxWidth: number): string {
        const cacheKey = `${text}|${maxWidth}|${ctx.font}`;

        if (cache[cacheKey]) {
            return cache[cacheKey];
        }

        if (ctx.measureText(text).width <= maxWidth) {
            cache[cacheKey] = text;
            return text;
        }

        let minCharCount = 0;
        let maxCharCount = text.length;
        while (minCharCount < maxCharCount) {
            const midCharCount = Math.ceil((minCharCount + maxCharCount) / 2);
            if (ctx.measureText(text.slice(0, midCharCount) + '...').width > maxWidth) {
                maxCharCount = midCharCount - 1;
            } else {
                minCharCount = midCharCount;
            }
        }

        cache[cacheKey] = text.slice(0, minCharCount) + '...';
        return cache[cacheKey];
    };
}
